import Controller, { OnBeforeFetch, OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { FragmentNames } from '../../codegen';
import { LocatorTableListAliases as Aliases } from '../../codegen/constants/aliases/locator-table-list-aliases';
import BaseController from '../BaseController';
import { Inject} from '@odinjs/odin';
import { FetchAPI, FieldAPI, TableAPI, TableColumnAPI } from '@philips-internal/oswald-ui-components';
import { ContextType } from '@philips-internal/oswald-ui-core';
import { SubmittableFragmentContext } from '@philips-internal/oswald-ui-core/lib/component';
import { MountEvent, SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { SubmitEventArgs } from '@philips-internal/oswald-ui-core/lib/component/types/submittable';
import { setLocator } from './locator-types';

export enum LocatorTypes {
  PHYSICAL_PERSON = 'PHYSICAL_PERSON',
  PROFESSIONAL_PERSON = 'PROFESSIONAL_PERSON',
  SAE_SEARCH = 'SAE_SEARCH'
}

@Controller({ fragment: FragmentNames.LOCATOR_TABLE_LIST })
export default class LocatorController extends BaseController {

  @Inject(ContextType.SUBMITTABLE_FRAGMENT)
    submittableFragmentContext!: SubmittableFragmentContext;

  @Inject(Aliases.FETCH)
    fetchApi!: FetchAPI;

  @Inject(Aliases.TABLE)
    tableAPI!: TableAPI;

  @Inject(Aliases.ID_TABLE_COLUMN)
    idColumnApi!: TableColumnAPI;

  @Inject(Aliases.NAME_TABLE_COLUMN)
    nameColumnApi!: TableColumnAPI;

  @OnBeforeFetch(Aliases.FETCH)
  handleMountFetch(): void {
    const locatorType = this.context.get('locator') as LocatorTypes;
    const locator = setLocator.find((data) => data.type === locatorType);
    const locatorRoute = locator?.route || '';
    this.fetchApi.setEndpoint(locatorRoute);
  }

  @OnMount(Aliases.NAME_FIELD)
  handleMountNameField(event: MountEvent): void {
    const fieldApi = event.target as FieldAPI;
    const locatorType = this.context.get('locator') as LocatorTypes;
    const locator = setLocator.find((data) => data.type === locatorType);
    const locatorEntry = locator?.entry || '';
    const locatorLabel = locator?.label || '';
    fieldApi.setEntry(locatorEntry);
    fieldApi.setLabel(locatorLabel);
  }

  @OnMount(Aliases.NAME_TABLE_COLUMN)
  handleMountTableColumn(): void {
    const locatorType = this.context.get('locator') as LocatorTypes;
    const locator = setLocator.find((data) => data.type === locatorType);
    const locatorIdColumn = locator?.idColumn || '';
    const locatorNameColumn = locator?.nameColumn || '';
    const locatorLabel = locator?.label || '';
    const locatorKeyLabel = locator?.keyLabel || '';
    const locatorKey = locator?.key || '';

    this.idColumnApi.setEntry(locatorIdColumn);
    this.nameColumnApi.setEntry(locatorNameColumn);
    this.nameColumnApi.setValue(locatorLabel);
    this.idColumnApi.setValue(locatorKeyLabel);
    this.tableAPI.setKeyField(locatorKey);
  }

  @OnClick(Aliases.SELECT_BUTTON)
  handleSelect(): void {
    const data = {
      record: this.tableAPI.getSelectedRows()[0],
    } as SubmitEventArgs;

    if(data.record) {
      this.submittableFragmentContext.submit(new SubmitEvent(data))
    }
  }
}
